import {
  renderEmptyState,
  renderSkeleton
} from "../render/ui-helpers.js";
import { renderHarnessThreadComponent, buildHarnessThreadTurns } from "./harness/render.js";
import { renderLLMThreadComponent } from "./llm/render.js";

export { threadMergeStateSuffix } from "./harness/render.js";

export function renderThreadComponent(state, options = {}) {
  if (state.notFound) {
    return renderEmptyState(
      options.notFoundTitle || "Thread not found",
      options.notFoundDescription || "The selected thread no longer exists.",
      options.notFoundActionHTML || ""
    );
  }
  if (!state.thread) {
    return renderSkeleton(5);
  }

  const current = state.thread;
  if (current.mode === "llm") {
    return renderLLMThreadComponent(state, options);
  }
  return renderHarnessThreadComponent(state, options);
}

export function buildThreadTurns(state) {
  if (String(state.thread?.mode || "") === "llm") {
    return [];
  }
  return buildHarnessThreadTurns(state);
}
